export default __webpack_public_path__ + "static/media/icons-5.e10504cd.svg";